import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import Button from '../../components/Button';
import { Building2 } from 'lucide-react';
import '../Login.css';

const AgencyLogin: React.FC = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const { login, user, loading: authLoading } = useAuth();
    const history = useHistory();

    // Redirect if already logged in
    React.useEffect(() => {
        if (!authLoading && user && user.role === 'agency') {
            window.location.href = '/agency/';
        }
    }, [user, authLoading]);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            // Trim to handle any whitespace from mobile keyboards
            const cleanUsername = username.trim();
            const cleanPassword = password.trim();

            console.log('[AgencyLogin] Attempting login for role: agency, username:', cleanUsername);

            await login(cleanUsername, cleanPassword, 'agency');
            // Redirect to the separate agencyend landing page
            window.location.href = '/agency/';
        } catch (err: any) {
            console.error('[AgencyLogin] Error:', err.message);
            setError(err.message || 'Login failed. Please check your credentials.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-container">
            <div className="login-card">
                <div className="login-header">
                    <div className="login-icon-wrapper" style={{ display: 'flex', justifyContent: 'center', marginBottom: '1rem' }}>
                        <Building2 size={48} className="text-primary" style={{ color: 'var(--primary-color)' }} />
                    </div>
                    <h1 className="login-title">Agency Login</h1>
                    <p className="login-subtitle">Sign in to manage your wedding agency account</p>
                </div>

                <form className="login-form" onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label htmlFor="username">Email or Mobile Number</label>
                        <input
                            type="text"
                            id="username"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            placeholder="Enter your email or mobile"
                            required
                            autoFocus
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="password">Password</label>
                        <input
                            type="password"
                            id="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="Enter your password"
                            required
                        />
                    </div>

                    {error && <div className="error-message">{error}</div>}

                    <Button
                        label={loading ? 'Signing in...' : 'Agency Sign In'}
                        onClick={() => { }}
                        disabled={loading}
                        className="login-button"
                    />
                </form>

                <div className="login-footer">
                    Want to become a partner? <br />
                    <a 
                        href="/agency/register" 
                        onClick={(e) => { 
                            e.preventDefault(); 
                            history.push('/agency/register'); 
                        }}
                    >
                        Apply for an Event Agency Account
                    </a>
                    <div style={{ marginTop: '1rem' }}>
                        <a 
                            href="/login" 
                            className="back-link"
                            onClick={(e) => { 
                                e.preventDefault(); 
                                history.push('/login'); 
                            }}
                        >
                            ← Back to regular login
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AgencyLogin;
